module.exports = __webpack_public_path__ + "static/img/news.9327925.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner/news.png
// module id = cEpR
// module chunks = 12